import CONSTANTS from 'core/data-model/constants/product'

export const getInsuranceLoanTermByProductCode = (productCode, { coverageTerm, loanTerm }) => {
  if (productCode === CONSTANTS.TRUNCATE_MRTA_PRODUCT_CODE) return loanTerm
  return coverageTerm
}
